// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nhtml{\n  overflow: hidden;\n}\n.dialog-mini .el-select {\n  width: 100%;\n}\n.el-tooltip__popper {\n  display: -webkit-box !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  -webkit-line-clamp: 15 !important;\n  -webkit-box-orient: vertical !important;\n}\n", ""]);
// Exports
module.exports = exports;
